import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChartItem } from 'chart.js';
import { Observable } from 'rxjs';
import { ChoroplethChart, topojson } from 'chartjs-chart-geo';
import { Topology } from 'topojson-specification';
import { Feature } from 'geojson';
import { mapAxisLabelEventPlugin } from '../plugins';
import { MapChartBaseComponent } from '../map-chart-base.component';
import { SimpleMatTooltipComponent } from '../../../../simple-mat-tooltip';
import { GEOMETRY_ID_COUNTRY_CODE_MAP, MAP_DEVICE_PIXEL_RATIO } from '../../../configs';
import { defaultOnLabelMouseMove } from '../../../plugins';

@Component({
    selector: 'app-countries-map-chart',
    templateUrl: './countries-map-chart.component.html',
    styleUrls: ['./countries-map-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CountriesMapChartComponent extends MapChartBaseComponent {

  protected getTopology(): Observable<Topology> {
    return this.geoChartJsonService.getCountriesObject();
  }

  protected createChart(context: ChartItem, data: number[], labels: string[], postfix: string, topology: Topology): ChoroplethChart {
    const countries: Array<Feature> = topojson.feature(topology, topology.objects.countries)['features'];
    const tooltip: SimpleMatTooltipComponent = this.tooltip();

    this.chart = new ChoroplethChart(context, {
      plugins: [
        mapAxisLabelEventPlugin
      ],
      data: {
        labels: countries.map((d) => d.properties.name),
        datasets: [{
          label: 'Countries',
          data: countries.map((feature) => {
            const abbr: string = GEOMETRY_ID_COUNTRY_CODE_MAP[feature.id];
            const index: number = labels.findIndex((label: string) => label === abbr);
            return {
              feature,
              value: index > -1 ? data[index] : 0,
            }
          })
        }]
      },
      options: {
        devicePixelRatio: MAP_DEVICE_PIXEL_RATIO,
        responsive: true,
        maintainAspectRatio: false,
        showOutline: true,
        plugins: {
          [mapAxisLabelEventPlugin.id]: {
            postfix: postfix,
            onLabelMouseMove: defaultOnLabelMouseMove(tooltip)
          },
          tooltip: { enabled: false },
          legend: { display: false },
          datalabels: { display: false }
        },
        scales: {
          color: {
            axis: 'x',
            quantize: this.calcMaxAvailableColors(data),
          },
          projection: {
            axis: 'x',
            projection: 'equalEarth'
          }
        }
      }
    });

    return this.chart;
  }
}
